// extracted by mini-css-extract-plugin
export var mainContentStyles = "main-content-module--mainContentStyles--8J59N";